import blogService from "../services/blogService";

export const GET_BLOG_CATEGORY_DETAILS = "GET_BLOG_CATEGORY_DETAILS"
export const GET_BLOG_CATEGORY_DETAILS_SUCCESS =
  "GET_BLOG_CATEGORY_DETAILS_SUCCESS"
export const GET_BLOG_CATEGORY_DETAILS_ERROR = "GET_BLOG_CATEGORY_DETAILS_ERROR"

export const CREATE_OR_UPDATE_BLOG_CATEGORY_DETAILS = "CREATE_OR_UPDATE_BLOG_CATEGORY_DETAILS"
export const CREATE_OR_UPDATE_BLOG_CATEGORY_DETAILS_SUCCESS =
  "CREATE_OR_UPDATE_BLOG_CATEGORY_DETAILS_SUCCESS"
export const CREATE_OR_UPDATE_BLOG_CATEGORY_DETAILS_ERROR =
  "CREATE_OR_UPDATE_BLOG_CATEGORY_DETAILS_ERROR"

export const GET_BLOG_POST = "GET_BLOG_POST";
export const GET_BLOG_POST_SUCCESS = "GET_BLOG_POST_SUCCESS";
export const GET_BLOG_POST_ERROR = "GET_BLOG_POST_ERROR";

export const CREATE_OR_UPDATE_BLOG_POST = "CREATE_OR_UPDATE_BLOG_POST";
export const CREATE_OR_UPDATE_BLOG_POST_SUCCESS =
  "CREATE_OR_UPDATE_BLOG_POST_SUCCESS";
export const CREATE_OR_UPDATE_BLOG_POST_ERROR =
  "CREATE_OR_UPDATE_BLOG_POST_ERROR";

export function getBlogPostRecord(data) {
  return async (dispatch) => {
    dispatch(getBlogPost(data));
    return await blogService
      .getBlogPost(data)

      .then((response) => dispatch(getBlogPostSuccess(response)))
      .catch((error) => dispatch(getBlogPostError(error)));
  };
}

export function getBlogPost() {
  return {
    type: GET_BLOG_POST,
  };
}

export function getBlogPostSuccess(success) {
  return {
    type: GET_BLOG_POST_SUCCESS,
    payload: { success },
  };
}

export function getBlogPostError(error) {
  return {
    type: GET_BLOG_POST_ERROR,
    payload: { error },
  };
}

export function createOrUpdateBlogPostRecord(blog) {
  return async (dispatch) => {
    dispatch(createOrUpdateBlogPost());
    return await blogService
      .createOrUpdateBlogPost(blog)

      .then((response) => dispatch(createOrUpdateBlogPostSuccess(response)))
      .catch((error) => dispatch(createOrUpdateBlogPostError(error)));
  };
}

export function createOrUpdateBlogPost() {
  return {
    type: CREATE_OR_UPDATE_BLOG_POST,
  };
}

export function createOrUpdateBlogPostSuccess(success) {
  return {
    type: CREATE_OR_UPDATE_BLOG_POST_SUCCESS,
    payload: { success },
  };
}

export function createOrUpdateBlogPostError(error) {
  return {
    type: CREATE_OR_UPDATE_BLOG_POST_ERROR,
    payload: { error },
  };
}

export function getBlogCategoryRecord() {
  return async (dispatch) => {
    dispatch(getBlogCategory())
    return await blogService
      .getBlogCategory()

      .then((response) => dispatch(getBlogCategorySuccess(response.data)))
      .catch((error) => dispatch(getBlogCategoryError(error)))
  }
}

export function getBlogCategory() {
  return {
    type: GET_BLOG_CATEGORY_DETAILS,
  }
}

export function getBlogCategorySuccess(success) {
  return {
    type: GET_BLOG_CATEGORY_DETAILS_SUCCESS,
    payload: { success },
  }
}

export function getBlogCategoryError(error) {
  return {
    type: GET_BLOG_CATEGORY_DETAILS_ERROR,
    payload: { error },
  }
}

export function createOrUpdateBlogCategoryRecord(blog) {
  return async (dispatch) => {
    dispatch(createOrUpdateBlogCategory())
    return await blogService
      .createOrUpdateBlogCategory(blog)
      
      .then((response) => dispatch(createOrUpdateBlogCategorySuccess(response)))
      .catch((error) => dispatch(createOrUpdateBlogCategoryError(error)))
  }
}

export function createOrUpdateBlogCategory() {
  return {
    type: CREATE_OR_UPDATE_BLOG_CATEGORY_DETAILS,
  }
}

export function createOrUpdateBlogCategorySuccess(success) {
  return {
    type: CREATE_OR_UPDATE_BLOG_CATEGORY_DETAILS_SUCCESS,
    payload: { success },
  }
}

export function createOrUpdateBlogCategoryError(error) {
  return {
    type: CREATE_OR_UPDATE_BLOG_CATEGORY_DETAILS_ERROR,
    payload: { error },
  }
}
